var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _c("div", { staticClass: "right-menu" }, [
        _c(
          "span",
          {
            staticClass: "svg-container",
            on: {
              click: function ($event) {
                return _vm.fullScreen()
              },
            },
          },
          [_c("svg-icon", { attrs: { "icon-class": "zoom-in" } })],
          1
        ),
        _c(
          "span",
          {
            staticClass: "svg-container",
            on: {
              click: function ($event) {
                return _vm.home()
              },
            },
          },
          [_c("svg-icon", { attrs: { "icon-class": "index" } })],
          1
        ),
        _c(
          "span",
          {
            staticClass: "svg-container",
            on: {
              click: function ($event) {
                return _vm.logout()
              },
            },
          },
          [_c("svg-icon", { attrs: { "icon-class": "logout" } })],
          1
        ),
      ]),
      _c("ai-dialog", {
        attrs: { visible: _vm.dialogVisible, "dialog-id": _vm.dialogId },
        on: {
          "update:visible": function ($event) {
            _vm.dialogVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }